<template>
  <div
    class="container float-container"
    v-bind:class="{ active: value || focused }"
  >
    <label :for="'text-' + _uid" :class="{ error: _error }">{{ label }}</label>
    <input
      ref="input"
      :id="'text-' + _uid"
      :name="'text-' + _uid"
      type="search"
      :placeholder="cHint"
      :value="value"
      :class="{ error: _error }"
      :pattern="pattern"
      :inputmode="inputmode"
      :maxlength="maxlength"
      :readonly="readonly"
      v-on:keypress="filter($event)"
      @blur="onBlur"
      @focus="onFocus"
      @input="onInput"
      @click="$emit('click')"
    />
    <span class="error" v-if="_error">
      <img src="@/assets/img/1x/error_icon.png" alt="" />
      <p>{{ _error }}</p>
    </span>
    <span v-if="!_error && subhint" class="subhint">
      <p>{{ subhint }}</p>
    </span>
  </div>
</template>

<script>
export default {
  name: "text-input-only-letters",
  props: {
    hint: String,
    label: String,
    value: String,
    name: String,
    pattern: String,
    inputmode: String,
    maxlength: String,
    subhint: String,
    readonly: Boolean,
    validationError: String,
    scrollOnFocus: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      tmpHint: "",
      actualHint: this.hint,
      focused: false
    };
  },
  replace: false,
  computed: {
    cHint() {
      return this.tmpHint;
    },
    _error() {
      /**
       * Verificar si el componente padre
       * pasó un error de validación por props
       * si no --> usar el error interno
       */
      if (this.validationError) {
        return this.validationError;
      }
      return this.error;
    }
  },
  methods: {
    /* Si bien se usa Pattern y NumericInput, al no utilizar type="number" deja ingresar texto
    Pero si le pongo type="numeric", Me deja de funcionar el boton de clear de type="search", con lo cual
    tengo que filtrar el ingreso... bsternari */
    filter(evt) {
      if (this.inputmode !== "numeric") {
        return true;
      }

      let charCode = evt.which ? evt.which : evt.keyCode;
      if (
        (charCode >= 64 && charCode <= 91) ||
        charCode >= 97 ||
        charCode <= 122
      ) {
        return true;
      } else {
        evt.preventDefault();
      }
    },
    onInput(e) {
      // Función para reemplazar caracteres acentuados
      let stripAccents = (function () {
        let in_chrs = "àáâãäçèéêëìíîïñòóôõöùúûüýÿÀÁÂÃÄÇÈÉÊËÌÍÎÏÑÒÓÔÕÖÙÚÛÜÝ",
          out_chrs = "aaaaaceeeeiiiinooooouuuuyyAAAAACEEEEIIIINOOOOOUUUUY",
          chars_rgx = new RegExp("[" + in_chrs + "]", "g"),
          transl = {},
          i,
          lookup = m => transl[m] || m;

        for (i = 0; i < in_chrs.length; i++) {
          transl[in_chrs[i]] = out_chrs[i];
        }

        return s => s.replace(chars_rgx, lookup);
      })();

      // No permitir caracteres acentuados
      e.target.value = stripAccents(e.target.value);
      this.$emit("input", e.target.value);
    },
    onBlur(e) {
      this.focused = false;
      this.$emit("onBlur");
      if (!e.target.value) {
        setTimeout(() => (this.tmpHint = ""), 180);
      }

      // Evento de interacción para GTM
      if (this.name) {
        this.gtmOnTextFieldBlur(this.name, this.value);
      }
    },
    onFocus() {
      this.focused = true;
      this.$emit("onFocus");
      this.$emit("focus");
      setTimeout(() => (this.tmpHint = this.actualHint), 180);
      /* Animar viewport para que el elemento quede arriba
      70 = alto de topbar + padding */
      if (this.scrollOnFocus) {
        window.scroll({
          top: this.$el.offsetTop - 70,
          left: 0,
          behavior: "smooth"
        });
      }
    },
    _focus() {
      /* Forzar el foco en el elemento
      método útil para que usen elementos padres */
      this.$refs.input.focus();
    }
  }
};
</script>

<style scoped>
input {
  /* Dar un poco de espacio para "centrar" el texto verticalmente */
  border-top: 17px solid transparent;
}

div.float-container {
  position: relative;
}

label {
  font-size: 15px;
  color: #666;
  font-family: "BentonSansBBVA-Book", Helvetica, Arial, sans-serif;
  position: absolute;
  -webkit-transform-origin: top left;
  transform-origin: top left;
  -webkit-transform: translate(16px, 19px) scale(1);
  transform: translate(16px, 19px) scale(1);
  transition: all 0.3s ease-in-out;
}
div.float-container.active label {
  -webkit-transform: translate(16px, 8px) scale(0.75);
  transform: translate(16px, 8px) scale(0.75);
}

/* Estilos para errores */
input.error {
  background: #fcdfdf;
}

label.error {
  color: #b92a45;
}

span.error {
  margin-left: 16px;
  margin-top: 8px;
  display: block;
}

span > img,
span > p {
  display: inline-block;
  vertical-align: top;
}

span > img {
  width: 16px;
}

span > p {
  margin-left: 2px;
  margin-top: 0px;
  margin-bottom: 0px;
  font-family: BentonSansBBVA-Light;
  font-size: 12px;
  line-height: 1.33;
  color: #121212;
}

/* Subhint */
span.subhint {
  display: block;
  padding-top: 5px;
}
</style>
